//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    iconBottom: {
      type: Boolean,
      default: false
    },
    loaded: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      observer: null,
      anchorsObserver: null,
      bottom: false,
      anchorActive: false,
      anchorOpened: false,
      anchorScrolled: false,
      anchors: [],
      path: null,
      dark: false,
      darkObserver: null
    }
  },
  updated() {
    if (this.path !== this.$router.history.current.path) {
      // При смене страницы через nuxt-link нужно удалить старые и создать новые Observer
      this.path = this.$router.history.current.path
      this.deleteObserver()
      this.createObserver()
    }
  },
  mounted() {
    if(this.loaded) {
      window.addEventListener('scroll', this.handleScroll)
      this.handleScroll ()
      this.path = this.$router.history.current.path
      this.createAnchors()
    }
  },
  watch: {
    loaded: function() {
      window.addEventListener('scroll', this.handleScroll)
      this.handleScroll ()
      this.path = this.$router.history.current.path
      this.createAnchors()
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, false);
    this.deleteObserver()
  },
  methods: {
    createAnchors(){
      document.querySelectorAll('.anchor-target').forEach(elem => {
        const link = `#${elem.getAttribute('id')}`
        const title = elem.getAttribute('data-title')
        if(link && title){
          this.anchors.push({
            name: title,
            link: link
          })
        }
      })
      this.createObserver()
    },
    handleAnchor(event) {
      const targetId = event.currentTarget.getAttribute('href')
      document.querySelector(targetId).scrollIntoView({
        behavior: 'smooth'
      });
    },
    openanchors() {
      this.anchorOpened = true
    },
    closeanchors () {
      this.anchorOpened = false
    },
    handleScroll () {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop
      const anchorCtn = document.querySelector('.anchor-wrap')
      this.anchorScrolled = currentScroll > (anchorCtn.offsetTop + anchorCtn.offsetHeight * 2)
    },
    deleteObserver() {
      document.querySelectorAll('.anchor-target').forEach(elem => {
        if(this.anchorsObserver) {
          this.anchorsObserver.unobserve(elem);
        }
      })
      if(this.observer) {
        this.observer.unobserve(document.querySelector('footer'))
      }
      document.querySelectorAll('.dark-trigger').forEach(elem => {
        if(this.darkObserver) {
          this.darkObserver.unobserve(elem);
        }
      })
    },
    createObserver() {
      setTimeout(() => {
        const margin = (window.innerHeight / 2 - 20) * -1;
        const options = {
          root: null,
          rootMargin: `${margin}px 0px ${margin}px 0px`,
          threshold: 0
        }

        this.anchorsObserver = new IntersectionObserver((entries, observer) => {
          for(let i = 0; i < entries.length; i++) {
            const anchorLinks = document.querySelectorAll('.anchor-link')
            if (anchorLinks.length === 1) {
              anchorLinks.forEach(elem => {
                elem.classList.remove("active")
              })
            }
            if (entries[i].isIntersecting) {
              const targetId = entries[i].target.getAttribute('id')
              const link = document.querySelector(`.anchor-link[href="#${targetId}"]`)
              if (anchorLinks.length > 1) {
                anchorLinks.forEach(elem => {
                  elem.classList.remove("active")
                })
              }
              if (link) {
                link.classList.add("active")
              }
            }
          }
        }, options)

        document.querySelectorAll('.anchor-target').forEach(elem => {
          this.anchorsObserver.observe(elem)
        })
      }, 500)

      setTimeout(() => {
        const profileAside = document.querySelector('.anchor-wrap')
        const profileAsideOffset = profileAside.offsetHeight + profileAside.offsetTop + 50
        const margin = (window.innerHeight - profileAsideOffset) * -1 + 'px'
        const options = {
          root: null,
          rootMargin: `1px 0px ${margin} 0px`,
          threshold: 0
        }

        this.darkObserver = new IntersectionObserver((entries, observer) => {
          for(let i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              this.dark = true
              return
            }
          }
          this.dark = false
        }, options)

        document.querySelectorAll('.dark-trigger').forEach(elem => {
          this.darkObserver.observe(elem)
        })
      }, 200)

      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          this.bottom = entry.isIntersecting
        })
      })

      this.observer.observe(document.querySelector('footer'))
    }
  },
}
